module.exports = __webpack_public_path__ + "static/media/felix.f11e6383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/felix.jpg
// module id = 435
// module chunks = 0